'use client';

import ArticlePagination from '@/components/articlePagination/ArticlePagination';
import HeadlineField from '@/components/customFields/HeadlineField';
import { HeadlineTag } from '@/components/customFields/types';
import NestedBlocks from '@/components/nestedBlocks/NestedBlocks';
import Stage from '@/components/stage/Stage';
import type { PagePressHomeStoryblok } from '@/types/component-types-sb';
import { type ISbStoryData, type SbBlokData, storyblokEditable } from '@storyblok/react/rsc';
import { useTranslation } from 'react-i18next';

import type { PageMagCategoryProps } from '../PageMagCategory';

export type PagePressHomeProps = Omit<PageMagCategoryProps, 'story' | 'blok'> & {
  story: ISbStoryData<PagePressHomeStoryblok>;
  blok?: PagePressHomeStoryblok | undefined;
};

export const PagePressHome: React.FC<PagePressHomeProps> = (props) => {
  const { t } = useTranslation();

  let title = props.blok?.Stage[0]?.title;
  if (props.page > 1) {
    title += ` / ${t('pagination.page')} ${props.page}`;
  }

  return (
    <div data-testid="press-home-page" {...storyblokEditable(props.blok as SbBlokData)}>
      <Stage
        content={props.page === 1 ? props.blok?.Stage[0]?.content : ''}
        title={title}
        media={props.blok?.Stage[0]?.media}
        imageAltTag={props.blok?.Stage[0]?.imageAltTag}
        type={props.page > 1 ? 'mini' : 'default'}
      />
      <div className="grid-wrapper">
        <div className="content-bloks-wrapper">
          <section>
            <HeadlineField tag={HeadlineTag.H2} style={HeadlineTag.H3}>
              {t('Pressemitteilungen')}
            </HeadlineField>

            <ArticlePagination
              articles={props.articles}
              baseUrl="ueber-uns/presse/"
              count={props.pages}
              page={props.page}
            />
          </section>

          <NestedBlocks blocks={props.blok?.content} />
        </div>
      </div>
    </div>
  );
};
export default PagePressHome;
